import { MenuConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { MenuDescriptionIcon } from '@framework/workbench/common/components/menu-description-icon';
import React from 'react';
import VIP_ICON from '@tencent/docs-design-resources/icon/mobile/svg/vip_minitag_12.svg';

export const config = {
    id: ActionType.IMAGES_JOINT,
    content: i18n.t('图片拼接'),
};

export const IMAGES_JOINT_MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        tooltip: config.content,
        description: <MenuDescriptionIcon iconSrc={VIP_ICON} />,
    },
];

